<template>
  <button type="button" class="account-button" slot="activator">
    <img src="../../../assets/icons/user.png" alt="User Icon" /> {{currentUserFullName}}
  </button>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('User', [
      'currentUserFullName',
    ]),
  },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/vars/theme';
@import '../../../styles/vars/typography';

.account-button {
  color: rgba(0, 0, 0, 0.55);
  font-family: $typography-font-secondary;
  font-size: 1.071rem;
  font-weight: $typography-weight-bold;
  margin-right: 0;
  outline: 0;
  padding: 12px 20px;
  text-transform: uppercase;
  white-space: nowrap;

  img {
    padding-right: 10px;
  }

  &:active,
  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
    outline: 0;
  }
}

@media only screen and (max-width: 960px) {
  .account-button {
    align-items: center;
    border-bottom: solid 1px rgba(0, 0, 0, 0.1);
    display: flex;
    padding: 15px 20px;
    width: 300px;
  }
}
</style>
